/**
 * 文件说明:
 *
 * Page title Header
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {memo, useMemo} from 'react'
import BreadcrumbHeader from './components/breadcrumb-header'
import TitleHeader from './components/title-header'

const typeMap = {
    breadcrumb: BreadcrumbHeader,
    title: TitleHeader,
}

const HzContentHeader = memo((props) => {
    const {
        pageHeaderOption,
        setHzHeaderHelp,
        PageComponent,
        pageProps,
        restoreHzHeaderHelp,
        useTitle,
    } = props

    const Component = useMemo(
        () => typeMap?.[pageHeaderOption?.contentType],
        [pageHeaderOption?.contentType],
    )

    if (!Component) {
        return null
    }

    return (
        <Component
            useTitle={useTitle}
            pageProps={pageProps}
            setHzHeaderHelp={setHzHeaderHelp}
            PageComponent={PageComponent}
            pageHeaderOption={pageHeaderOption}
            restoreHzHeaderHelp={restoreHzHeaderHelp}
        />
    )
})

export default HzContentHeader
